import Backbone from 'backbone';

export default Backbone.Model.extend({});



/** WEBPACK FOOTER **
 ** ./legacy/home24-desktop/core/baseModel.js
 **/